<div id="virtueAlertBox">
	<div  class="alert-box" *ngIf="showAlter" id="vab">
		<div class="alert alert-{{msg.key}} alert-dismissible">
			<span class="close" (click)="remove()" >×</span>
			{{msg.text}}
		</div>
	</div>
</div>